<template>
	<ModalFormCard
		:action="action"
		:submittedCallback="submittedCallback"
		class="modal-default"
	>
		<template #title>Edit lead</template>
        
        <template #default="{ saving, errors }">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
                <Input
                    v-model:value="value.first_name"
                    :ai="ai"
                    groupClass="bg-grey text-15"
                    label="First name"
                    name="first_name"
                    placeholder="First name"
                />

                <Input
                    v-model:value="value.last_name"
                    :ai="ai"
                    groupClass="bg-grey text-15"
                    label="Last name"
                    name="last_name"
                    placeholder="Last name"
                />
            </div>

            <Input
                v-model:value="value.email"
                :ai="ai"
                class="mt-4"
                groupClass="bg-grey text-15"
                label="Email address"
                name="email"
                placeholder="Email address"
            />

            <Select
                v-model:value="value.title"
                :ai="ai"
                aiName='category'
                :options="leadCategories"
                class="mt-4"
                label="Lead category"
                name="title"
                placeholder="Select category"
                selectClass="!bg-grey text-15"
            >
            </Select>

            <Textarea
                v-model:value="value.description"
                :ai="ai"
                rows="6"
                class="mt-4"
                groupClass="bg-grey text-15"
                label="Description"
                name="description"
                aiName='summary'
            />

            <div class="grid lg:grid-cols-2 pt-8 gap-3">
				<ButtonSaving
					:disabled="saving"
					class="button-black h-12"
				>
					Update lead
				</ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Lead from "~/models/lead.js";
import Modal from "~/mixins/modal.js";

export default {
	mixins: [Modal],

	created() {
		this.setup(Lead);
	},

    computed: {
        leadCategories() {
            return this.options.leadCategories
        },

        ai() {
			return this.editingModel.ai_current != null
				? JSON.parse(this.editingModel.ai_current.body)
				: false;
		},
    }
}
</script>